import { Container, Row, Col, Card, Figure } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function Home() {

  return (
    <Container className="px-5 home-con" id='body'>
      <Row>

        <Col sm={7} className='home-col'>
          <Card className='bg-dark'>
            <Card.Body>
              <Card.Title className='text-center home-text-title'><h4><b>บริการหลัก</b></h4></Card.Title><br />
              <h6><b className='saraban'>• Authorization Service (Oauth 2.0)</b></h6><br />
              <p>ให้บริการยืนยันตัวตนผู้ใช้งานในบริการต่างๆ ภายในมหาวิทยาลัยเทคโนโลยีราชมงคลอีสาน
                โดยผู้ใช้จะต้องเข้าสู่ระบบผ่าน SSO ของมหาวิทยาลัย ก่อนที่จะเข้าใช้งานบริการนั้นๆ
              </p><br />
              <h6><b className='saraban'>• Data Service (การบริการด้านข้อมูล)</b></h6><br />
              <p>ให้บริการข้อมูลสำหรับระบบที่ต้องการเชื่อมต่อผ่าน SSO และต้องการใช้ข้อมูลที่เกี่ยวข้องกับฐานข้อมูลของมหาวิยาลัย
                ระบบนี้สามารถให้ข้อมูลนักศึกษาและบุคลากรตามที่ร้องขอ โดยครอบคลุมทั้ง 4 วิทยาเขต
                และส่งข้อมูลด้วยวิธี Fetch API ผ่าน GET/POST request
              </p><br />
              <p>
                *SSO (Single Sign-On) คือวิธียืนยันตัวตนที่ช่วยให้ผู้ใช้ตรวจสอบและยืนยันสิทธิ์ในการเข้าถึงบริการต่างๆ
                ไม่ว่าจะเป็นเว็บไซต์หรือแอปพลิเคชัน ได้ด้วยบัญชีเพียงบัญชีเดียว โดยที่ผู้ใช้ไม่จำเป็นต้องสมัครสมาชิกใหม่
                เพียงแค่ใช้บัญชีสมาชิกอินเทอร์เน็ตมหาวิทยาลัยในการเข้าสู่ระบบเท่านั้น
              </p>
            </Card.Body>
          </Card>
        </Col>

        <Col sm={5} className='text-center py-4'>

          <Card>
            <Card.Body>
              <a href='https://forms.office.com/r/2vnBihsLcD' target='#' rel="noopener noreferrer" className='home-text'>
                <Figure className='fig2'>
                  <Figure.Image
                    width={50}
                    height={50}
                    src='icon/google-forms.png'>
                  </Figure.Image><br />
                  <b className='home-title'>แบบฟอร์มขอใช้งานระบบบริการข้อมูล (API)</b><br /><br />
                  <Figure.Caption>
                    แบบฟอร์ม <br /> เพื่อขอใช้งานบริการ sso และรับข้อมูลที่ต้องการผ่านทาง api
                  </Figure.Caption>
                </Figure>
              </a>
            </Card.Body>
          </Card><br />

          <Card>
            <Card.Body>
              {/*<Link to={'/userManualsAPI'} className='home-text'>*/}
                <Figure className='fig1'>
                  <Figure.Image
                    width={50}
                    height={50}
                    src='icon/gear.png'>
                  </Figure.Image><br />
                  <b className='home-title'>วิธีการใช้งาน RMUTI API SERVICE</b><br /><br />
                  <Figure.Caption>
                    {/*เกี่ยวกับการใช้งานระบบ API <br /> ซึ่งนักศึกษา และบุคลากรในมหาวิทยาลัย สามารถใช้งานได้*/}
                    <Link to={'/userManualsAPI'} className="fig1-2 text-fig1">คู่มือการใช้งาน API ด้วยวิธี GET/POST</Link><br/>
                    <a href='document/คู่มือการดึงข้อมูล API ด้วย Postman - RMUTI API.pdf' className="fig1-2 text-fig1" target='#' rel="noopener noreferrer">
                      คู่มือการใช้งาน API ผ่าน Postman
                    </a>
                  </Figure.Caption>
                </Figure>
              {/*</Link>*/}
            </Card.Body>
          </Card><br />

        </Col>
      </Row>

      
      <Row className='text-center home-col'>
        <Col>
          <a href='https://www.voip-services.rmuti.ac.th/all_ipphone.php' target='#' rel="noopener noreferrer"
            >
            <Figure className='img'>
              <Figure.Image
                src='icon/icon (4).png'
                width={250}
                height={250}
                alt="200x200">
              </Figure.Image>
            </Figure>
          </a>
        </Col>

        <Col>
          <a href='https://mis.rmuti.ac.th/' target='#' rel="noopener noreferrer"
            >
            <Figure className='img'>
              <Figure.Image
                src='icon/icon (1).png'
                width={250}
                height={250}
                alt="200x200">
              </Figure.Image>
            </Figure>
          </a>
        </Col>

        <Col>
          <a href='https://network.rmuti.ac.th/main/' target='#' rel="noopener noreferrer"
            >
            <Figure className='img'>
              <Figure.Image
                src='icon/icon (2).png'
                width={250}
                height={250}
                alt="200x200">
              </Figure.Image>
            </Figure>
          </a>
        </Col>

        <Col>
          <a href='https://www.facebook.com/ita.rmuti/' target='#' rel="noopener noreferrer"
            >
            <Figure className='img'>
              <Figure.Image
                src='icon/icon (3).png'
                width={250}
                height={250}
                alt="200x200">
              </Figure.Image>
            </Figure>
          </a>
        </Col>
      </Row>
    </Container>
  )
}

export default Home;